"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const store_1 = require("../store");
function ErrorMsgs(extraProps) {
    const errors = (0, store_1.useAppSelector)(state => state.errors);
    const formStatus = (0, store_1.useAppSelector)(state => state.status);
    if (!errors.length)
        return react_1.default.createElement(react_1.default.Fragment, null);
    if (formStatus !== 'ERROR' && formStatus !== 'WAITING')
        return react_1.default.createElement(react_1.default.Fragment, null);
    return (react_1.default.createElement("ul", Object.assign({}, extraProps), errors.map((msg) => (react_1.default.createElement("li", { key: msg }, msg)))));
}
exports.default = ErrorMsgs;
